var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_648_25253_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.00900866 -0.00213363 0.00213363 -0.00900866 10.4633 7.28679)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1346.18,
    y: -1346.18,
    width: 2692.36,
    height: 2692.36
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(215, 31, 39, 0) 0deg,rgba(215, 32, 39, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 6.33333H11.6667C11.6667 9.27885 9.27885 11.6667 6.33333 11.6667V12.1667V12.6667C9.83114 12.6667 12.6667 9.83114 12.6667 6.33333H12.1667ZM6.33333 12.1667V11.6667C3.38781 11.6667 1 9.27885 1 6.33333H0.5H0C0 9.83114 2.83553 12.6667 6.33333 12.6667V12.1667ZM0.5 6.33333H1C1 3.38781 3.38781 1 6.33333 1V0.5V0C2.83553 0 0 2.83553 0 6.33333H0.5ZM6.33333 0.5V1C9.27885 1 11.6667 3.38781 11.6667 6.33333H12.1667H12.6667C12.6667 2.83553 9.83114 0 6.33333 0V0.5Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.84313726425170898,\"g\":0.12549018859863281,\"b\":0.15294119715690613,\"a\":0.0},\"position\":0.0},{\"color\":{\"r\":0.84313726425170898,\"g\":0.12549020349979401,\"b\":0.15294118225574493,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":-18.017318725585938,\"m01\":4.2672586441040039,\"m02\":17.338359832763672,\"m10\":-4.2672586441040039,\"m11\":-18.017318725585938,\"m12\":18.429075241088867},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_648_25253_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 6.33333H11.6667C11.6667 9.27885 9.27885 11.6667 6.33333 11.6667V12.1667V12.6667C9.83114 12.6667 12.6667 9.83114 12.6667 6.33333H12.1667ZM6.33333 12.1667V11.6667C3.38781 11.6667 1 9.27885 1 6.33333H0.5H0C0 9.83114 2.83553 12.6667 6.33333 12.6667V12.1667ZM0.5 6.33333H1C1 3.38781 3.38781 1 6.33333 1V0.5V0C2.83553 0 0 2.83553 0 6.33333H0.5ZM6.33333 0.5V1C9.27885 1 11.6667 3.38781 11.6667 6.33333H12.1667H12.6667C12.6667 2.83553 9.83114 0 6.33333 0V0.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.1b12eb7fdbff64667b2962c74a7e8be9.svg";
export { ForwardRef as ReactComponent };